import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getUsuario } from "../../services/apiUsuario";
import { getCidade } from "../../services/apiCidade";
import { Helmet } from "react-helmet";
import InputGenerico from "../../components/inputGenerico/inputGenerico";
import SelectGenerico from "../../components/selectGenerico/selectGenerico";
import BotaoVoltar from "../../components/botoes/BotaoVoltar";

interface Usuario {
  cdCidade: number;
  nmUsuario: string;
  nmEmail: string;
  nmSexo: string;
  nmLogradouro: string;
  nmBairro: string;
  nmComplemento: string;
  dsLogin: string;
  dsCpf: string;
  dsCep: string;
  dsContato: string;
  dsContatoOpcional: string;
  dtNascimento: string;
  nrLogradouro: number;
  dmResidencial: boolean;
}

export default function VisualizarUsuario() {
  const { cdUsuario } = useParams();
  const [cidade, setCidade] = useState<{
    cdCidade: number;
    nmCidade: string;
  } | null>(null);
  const [usuario, setUsuario] = useState<Usuario>();
  const formatCPF = (cpf: string) => {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };
  const formatPhone = (phone: string) => {
    return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  };
  const formatCEP = (cep: string) => {
    return cep.replace(/(\d{5})(\d{3})/, "$1-$2");
  };
  const formatDate = (date: string) => {
    const [year, month, day] = date.split("T")[0].split("-");
    return `${day}/${month}/${year}`;
  };
  const sexoOptions = [
    { valor: "M", rotulo: "Masculino" },
    { valor: "F", rotulo: "Feminino" },
    { valor: "O", rotulo: "Outro" },
  ];
  const getSexoLabel = (sexo: string) => {
    switch (sexo) {
      case "M":
        return "Masculino";
      case "F":
        return "Feminino";
      default:
        return "Outro";
    }
  };
  const fetchUsuario = async (cd: any) => {
    try {
      const response = await getUsuario(cd);
      setUsuario(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  const fetchCidade = async (cdCidade: number) => {
    try {
      if (usuario) {
        const response = await getCidade(cdCidade.toString());
        if (response.data) {
          setCidade(response.data);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (cdUsuario) {
      fetchUsuario(cdUsuario);
    }
  }, [cdUsuario]);
  useEffect(() => {
    if (usuario) {
      fetchCidade(usuario.cdCidade);
    }
  }, [usuario]);

  return (
    <>
      <Helmet>
        <title>Visualizar usuário</title>
      </Helmet>
      <div className="container">
        <div
          className="card bg-light mb-4 shadow p-3 mb-5 rounded"
          style={{ width: "auto", border: "none" }}
        >

          <div className="card-body">
            <div className="container">
              <div className="row align-items-start">
                {usuario && (
                  <div className="container">
                    <div className="row">
                      <div className="col">
                        <InputGenerico
                          name="nomeUsuario"
                          disabled={true}
                          value={usuario.nmUsuario}
                          label="Nome*:"
                          placeholder={usuario.nmUsuario}
                          className="form-control mb-4"
                          validacaoAtiva={false}
                          type="text"
                          maxLength={100}
                        />
                        <InputGenerico
                          name="user"
                          disabled={true}
                          value={usuario.dsLogin}
                          label="Apelido*:"
                          placeholder={usuario.dsLogin}
                          className="form-control mb-4"
                          validacaoAtiva={false}
                          type="text"
                          maxLength={100}
                        />
                        <InputGenerico
                          name="email"
                          disabled={true}
                          value={usuario.nmEmail}
                          label="E-mail*:"
                          placeholder={usuario.nmEmail}
                          className="form-control mb-4"
                          validacaoAtiva={false}
                          type="email"
                          maxLength={100}
                        />
                        <InputGenerico
                          name="cpf"
                          disabled={true}
                          value={formatCPF(usuario.dsCpf)}
                          label="CPF*:"
                          placeholder={formatCPF(usuario.dsCpf)}
                          className="form-control mb-4"
                          validacaoAtiva={false}
                          type="text"
                          maxLength={14}
                        />
                      </div>
                      <div className="col">
                        <InputGenerico
                          name="dataNascimento"
                          disabled={true}
                          value={formatDate(usuario.dtNascimento)}
                          label="Data de nascimento*:"
                          placeholder={formatDate(usuario.dtNascimento)}
                          className="form-control mb-4"
                          validacaoAtiva={false}
                          type="text"
                        />
                        <SelectGenerico
                          disabled={true}
                          opcoes={sexoOptions}
                          valorSelecionado={usuario.nmSexo}
                          label="Sexo*:"
                          mensagemError="erro"
                          opcaoPadrao={getSexoLabel(usuario.nmSexo)}
                          classe="selectUf form-select mb-4"
                          classPadrao="corOption"
                          validacaoAtiva={false}
                        />
                        <InputGenerico
                          name="telefone"
                          disabled={true}
                          value={formatPhone(usuario.dsContato)}
                          label="Telefone*:"
                          placeholder={formatPhone(usuario.dsContato)}
                          className="form-control mb-4"
                          validacaoAtiva={false}
                          type="text"
                          maxLength={15}
                        />
                        <InputGenerico
                          name="telefoneOpcional"
                          disabled={true}
                          value={formatPhone(usuario.dsContatoOpcional)}
                          label="Telefone Opcional:"
                          placeholder={
                            usuario.dsContatoOpcional
                              ? formatPhone(usuario.dsContatoOpcional)
                              : ""
                          }
                          className="form-control mb-4"
                          validacaoAtiva={false}
                          type="text"
                          maxLength={15}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {usuario && (
          <div
            className="card bg-light mb-4 shadow p-3 mb-5 rounded"
            style={{ width: "auto", border: "none" }}
          >
            <div className="card-body">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <InputGenerico
                      name="cep"
                      disabled={true}
                      value={formatCEP(usuario.dsCep)}
                      label="CEP:"
                      placeholder={formatCEP(usuario.dsCep)}
                      className="form-control mb-4"
                      validacaoAtiva={false}
                      type="text"
                      maxLength={9}
                    />
                    <InputGenerico
                      name="rua"
                      disabled={true}
                      value={usuario.nmLogradouro}
                      label="Rua*:"
                      placeholder={usuario.nmLogradouro}
                      className={`form-control mb-4 `}
                      validacaoAtiva={false}
                      type="text"
                    />
                    <InputGenerico
                      name="numero"
                      disabled={true}
                      value={usuario.nrLogradouro.toString()}
                      label="Número*:"
                      placeholder={usuario.nrLogradouro.toString()}
                      className={`form-control mb-4 `}
                      validacaoAtiva={false}
                      type="text"
                    />
                    <div className="d-flex gap-2 mt-2">
                      <label htmlFor="residencial">Endereço residencial?</label>
                      <div>
                        <input
                          id="residencialSim"
                          name="residencial"
                          disabled={true}
                          value="sim"
                          checked={usuario.dmResidencial}
                          type="radio"
                          className="me-1"
                        />
                        <label htmlFor="residencialSim">Sim</label>
                      </div>
                      <div>
                        <input
                          id="residencialNao"
                          name="residencial"
                          disabled={true}
                          value="nao"
                          checked={!usuario.dmResidencial}
                          type="radio"
                          className="me-1"
                        />
                        <label htmlFor="residencialNao">Não</label>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <InputGenerico
                      name="bairro"
                      disabled={true}
                      value={usuario.nmBairro}
                      label="Bairro*:"
                      placeholder={usuario.nmBairro}
                      className={`form-control mb-4 `}
                      validacaoAtiva={false}
                      type="text"
                      maxLength={100}
                    />
                    <SelectGenerico
                      disabled={true}
                      opcoes={[
                        {
                          valor: cidade?.cdCidade ?? "",
                          rotulo: cidade?.nmCidade ?? "",
                        },
                      ]}
                      valorSelecionado={cidade?.cdCidade ?? ""}
                      label="Cidade*:"
                      mensagemError="Não há cidades a serem listados"
                      classe={`selectUf form-select mb-3 `}
                      classPadrao="corOption"
                      validacaoAtiva={false}
                    />
                    <InputGenerico
                      name="complemento"
                      disabled={true}
                      value={usuario.nmComplemento}
                      label="Complemento:"
                      placeholder={usuario.nmComplemento}
                      className={`form-control mb-4 `}
                      validacaoAtiva={false}
                      rows={2}
                      maxLength={100}
                      type="textarea"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <BotaoVoltar/>
      </div>
    </>
  );
}
